<template>
  <component :is="createComponent" />
</template>

<script>
import { computed } from 'vue'
import CreateConfigAdventureIsland from './CreateConfigAdventureIsland.vue'
import CreateConfigAdventureIslandKorea from './CreateConfigAdventureIslandKorea.vue'

const GAME_KOREA = '冒险岛韩服'

function resolveUserGame() {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    return user.game || ''
  } catch {
    return ''
  }
}

export default {
  name: 'ConfigCreateWrapper',
  setup() {
    const createComponent = computed(() =>
      resolveUserGame() === GAME_KOREA
        ? CreateConfigAdventureIslandKorea
        : CreateConfigAdventureIsland
    )
    return { createComponent }
  }
}
</script>
